// Hook usunięcia komentarza do oferty (nagłówka).
// DELETE /sales-crm/clients/:cid/offers/:oid/comments/:commentId

import { axios } from 'api';
import { useMutation, UseMutationOptions } from 'react-query';
import { ICommandResponseError as IError, ICommandResponseSuccess } from 'api/types';

type IResponse = ICommandResponseSuccess;

const deleteSalesCrmOfferComment = (
  clientId: number,
  offerId: string,
  commentId: number
): Promise<IResponse> =>
  axios.delete(`/sales-crm/clients/${clientId}/offers/${offerId}/comments/${commentId}`);

export const useDeleteSalesCrmOfferComment = (
  clientId: number,
  offerId: string,
  options?: UseMutationOptions<IResponse, IError, number>
) =>
  useMutation(
    (commentId: number) => deleteSalesCrmOfferComment(clientId, offerId, commentId),
    options
  );
